const FadeGallery = () => {
  const items = [...document.querySelectorAll('.js-fade-gallery-item')]
  const buttons = [...document.querySelectorAll('.js-fade-gallery-nav-item')]

  if (!items.length || !buttons.length) return

  buttons.forEach(button => {
    button.addEventListener('click', function (e) {
      clearAll()
      const { target } = this.dataset
      this.classList.add('c-fade-gallery-nav__item--is-active')
      document.getElementById(target).classList.add('c-fade-gallery__item--is-active')
    })
  })

  const clearAll = () => {
    items.forEach(el => {
      el.classList.remove('c-fade-gallery__item--is-active')
    })
    buttons.forEach(el => {
      el.classList.remove('c-fade-gallery-nav__item--is-active')
    })
  }
}

export default FadeGallery



// WEBPACK FOOTER //
// ./src/js/modules/FadeGallery.js